import * as React from "react";
import { useEffect, Fragment } from "react";
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import { FaRegCircleUser } from "react-icons/fa6";
import IconButton from "@mui/material/IconButton";
import CssBaseline from "@mui/material/CssBaseline";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineNotifications } from "react-icons/md";
import ListItemButton from "@mui/material/ListItemButton";
import { AppBar, Toolbar, Box, styled, Typography } from "@mui/material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import pages from "../../../constants/pages";
import DigipassLogo from "../assets/digipasslogo.svg";
import { signOutMember } from "../../../redux/slices/memberSlice";

import useAxios from "../../../hooks/useAxios";

const StyledAppBar = styled(AppBar)({
  background: "transparent",
  boxShadow: "none",
});

const MenuItems = styled("div")({
  display: "flex",
  alignItems: "center",
  "& a": {
    color: "#ffffff",
    fontWeight: 500,
    textDecoration: "none",
    fontSize: "16px",
    margin: "0 1rem",
    position: "relative",
    "&:hover": {
      color: "#6366f1",
      "&::before": {
        content: "''",
        position: "absolute",
        left: 0,
        right: 0,
        bottom: "-2px",
        height: "3px",
        background: "#6366f1",
        transition: "width 0.3s ease",
        width: "100%",
      },
    },
  },
});

const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    backgroundColor: "rgba(15, 23, 42, 0.95)",
    backdropFilter: "blur(20px)",
    color: "#f8fafc",
    marginTop: "0",
    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
  },
});

export default function AgentNavbar(props) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [logo, setLogo] = React.useState(DigipassLogo);

  const [disableOption, setDisableOption] = React.useState(
    window.location.origin.includes("https://kyc.globalfintechfest.com")
  );

  const [profileVerify, setProfileVerify] = React.useState("");

  useEffect(() => {
    setDisableOption(
      window.location.origin.includes("https://kyc.globalfintechfest.com")
    );
  });

  useEffect(() => {
    if (sessionStorage.getItem("authToken")) {
      axios({
        url: "/admin/business/get-business-theme",
        customAuthToken: sessionStorage.getItem("authToken"),
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setLogo(response.data.logo);
        }
      });
    }
  }, []);

  const navItems = [
    // { text: "Auto", link: pages.MainGateEntryWithBackCamera.route },
    // { text: "Manual", link: pages.ManualEntry.route },
    // { text: "Resend", link: pages.ResendNotification.route },
    // { text: "Verify", link: pages.ManualVerification.route },
    // { text: "Booking Stats", link: pages.BookingStats.route },
    // { text: "Warden", link: pages.WardenFlow.route },
    { text: "Guard", link: pages.GuardFlow.route },
    { text: "Users", link: pages.GuardUserDetails.route },
    { text: "Scan QR", link: pages.ScanQR.route },
    { text: "Guest Verification", link: pages.GuestVerification.route },
    { text: "Log Out", link: pages.SignIn.route },
  ];

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (!location.pathname.includes("event")) {
      sessionStorage.removeItem("buttonBackground");
      sessionStorage.removeItem("buttonColor");
    }
  }, [location.pathname]);

  const drawer = (
    <Box
      sx={{ textAlign: "center", marginTop: "0rem", padding: "1rem" }}
      onClick={handleDrawerToggle}
    >
      <List>
        {navItems.map((item) => (
          <Fragment key={item.text}>
            <ListItem
              disablePadding
              onClick={() => {
                navigate(item.link);
              }}
            >
              <ListItemButton
                onClick={() =>
                  item.text === "Log Out" && dispatch(signOutMember())
                }
              >
                <ListItemText
                  primary={
                    <Typography
                      component={Link}
                      sx={{
                        color: location.pathname.includes("event")
                          ? sessionStorage.getItem("buttonBackground") ||
                            "rgb(84, 82, 238)"
                          : "rgb(84, 82, 238)",
                        fontWeight: 600,
                        textDecoration: "none",
                        fontSize: "1rem",
                        "&:hover": {
                          color: location.pathname.includes("event")
                            ? sessionStorage.getItem("buttonBackground") ||
                              "rgb(84, 82, 238)"
                            : "rgb(57, 54, 239)",
                        },
                      }}
                    >
                      {item.text}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window?.document.body : undefined;

  const handleProfile = () => {
    if (!localStorage.getItem("authToken")) {
      navigate(pages.appointment.route);
    } else {
      navigate(pages.Profile.route);
    }
  };

  useEffect(() => {
    setProfileVerify(localStorage.getItem(window.btoa(visitorData.ID)));
  });

  return (
    <Box
      sx={{
        display: "flex",
        position: "fixed",
        width: "100%",
        background: "rgba(15, 23, 42, 0.4) !important",
        backdropFilter: "blur(20px)",
        zIndex: "9999",
        borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
        pointerEvents: disableOption ? "none" : "auto",
      }}
    >
      <CssBaseline />
      <StyledAppBar position="static">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              disabled={disableOption}
            >
              <MenuIcon
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                }}
              />
            </IconButton>

            <img
              src={logo}
              width={"145px"}
              onClick={() => {
                // navigate(pages.home.route);
              }}
            />

            {/* <Typography
              variant="h3"
              color={
                location.pathname.includes("event")
                  ? sessionStorage.getItem("buttonBackground") ||
                    "rgb(84, 82, 238)"
                  : "rgb(84, 82, 238)"
              }
              fontWeight={900}
              onClick={() => {
                navigate(pages.home.route);
              }}
            >
              Digipass
            </Typography> */}
          </Box>
          <MenuItems sx={{ display: { xs: "none", sm: "flex" } }}></MenuItems>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <IconButton color="inherit">
              <MdOutlineNotifications
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                  fontSize: "24px",
                }}
              />
            </IconButton> */}

            {/* <IconButton color="inherit" onClick={() => handleProfile()}>
              {profileVerify == "false" && (
                <PriorityHighIcon
                  style={{
                    color: "#ff6b6b",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    background: "#ffffff",
                    borderRadius: "10px",
                    fontSize: "20px",
                    border: "2px solid",
                  }}
                />
              )}
              <FaRegCircleUser
                style={{
                  color: location.pathname.includes("event")
                    ? sessionStorage.getItem("buttonBackground") ||
                      "rgb(84, 82, 238)"
                    : "#3936EF",
                  fontSize: "24px",
                }}
              />
            </IconButton> */}
          </Box>
        </Toolbar>
      </StyledAppBar>
      <Box component="nav">
        <StyledDrawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          disabled={disableOption}
        >
          {drawer}
        </StyledDrawer>
      </Box>
    </Box>
  );
}
